// src/pages/RegistrationFuiteDonnees/components/SuccessConfirmStep.tsx
import React, { useEffect, useState } from "react";
import './SuccessConfirmStep.scss';
import Button from "./UI/Button";
import { ReactComponent as PlayStore } from "assets/img/Play_Store.svg";
import { ReactComponent as AppStore } from "assets/img/Apple_Store.svg";
import { ReactComponent as RightArrow } from "assets/img/icons/icon_arrow-Right.svg";
import { ReactComponent as IconSuccess } from "assets/img/icons/Icon_success.svg";
import { useNavigate } from "react-router-dom";
import { resend } from "features/account";
import Alert from "shared/ui/Alert";
import { APPLE_STORE_LINK, PLAY_STORE_LINK } from "utils/utils";
import { localStorageUtil } from "shared/lib/localStorage_util";


interface SuccessConfirmStepProps {
  email: string | null;
}

const SuccessConfirmStep: React.FC<SuccessConfirmStepProps> = ({
                                                                 email,
                                                               }) => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const onGoToHome = () => {
    navigate('/particuliers/login');
  }

  const onGoSubscribe = () => {
    window.open(`/fuites-donnees/pricing`, '_blank');
  }

  const onDownloadAppStore = () => {
    window.open(`${APPLE_STORE_LINK}`, '_blank');
  }

  const onDownloadGooglePlay = () => {
    window.open(`${PLAY_STORE_LINK}`, '_blank');
  }

  const onResendEmail = async () => {
    setIsLoading(true);
    try {
      const response = await resend(email, "v");
      setIsLoading(false);
      setSuccessMessage("Un nouveau lien de confirmation vous a été envoyé par email.");
      setErrorMessage("");
    } catch (error: any) {
      setSuccessMessage("")
      setErrorMessage(error.response.data.error);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    localStorageUtil.remove(localStorageUtil.KEYS.REGISTRATION_SESSION);
  }, [])

  return (
    <div className={"SuccessConfirmStep"}>
      <div className={"SuccessConfirmStepBody"}>
        <div className="SuccessConfirmStep-container">
          <div className="success-confirm-step">
            {/* Success Header */}
            <div className="success-confirm-step__header">
              <div className="success-confirm-step__icon">
                <IconSuccess />
              </div>
              <p className="success-confirm-step__title">Inscription réussie !</p>
            </div>

            {/* Email Confirmation Section */}
            <div className="success-confirm-step__email-section">
              {errorMessage !== "" && (<Alert type="error">{errorMessage}</Alert>)}
              {successMessage !== "" && <Alert type="success">{successMessage}</Alert>}
              <p className="success-confirm-step__email-label">Email de confirmation à :</p>
              <p className="success-confirm-step__email-address">
                <span>{email}</span>
              </p>
              <p className="success-confirm-step__resend">
                Vous n'avez pas reçu l'email ? Vérifiez vos spams ou
                {!isLoading && (
                  <span
                    className="success-confirm-step__resend-btn"
                    onClick={onResendEmail}
                  >
                  renvoyez l'email
                </span>
                )}
                {isLoading && (
                  <span>Patientez...</span>
                )}
              </p>
            </div>

            {/* Divider */}
            <div className="success-confirm-step__divider"></div>

            {/* Next Steps */}
            <div className="success-confirm-step__next-steps">
              <p className="success-confirm-step__subtitle">Les prochaines étapes :</p>
              <ol className="success-confirm-step__steps-list">
                <li className="success-confirm-step__step">
            <span className="success-confirm-step__step-text">
              Vos données sont présentées au sein de notre réseau
            </span>
                </li>
                <li className="success-confirm-step__step">
            <span className="success-confirm-step__step-text">
              Vous êtes immédiatement notifiés sur l'application ID Protect
            </span>
                </li>
                <li className="success-confirm-step__step">
            <span className="success-confirm-step__step-text">
              Vous validez ou vous refusez l'usage de vos données en temps réel
            </span>
                </li>
              </ol>
            </div>

            {/* Divider */}
            <div className="success-confirm-step__divider"></div>

            {/* Mobile App Download */}
            <div className="success-confirm-step__app-download">
              <p className="success-confirm-step__subtitle">Téléchargez l'application mobile</p>

              <div className="success-confirm-step__download-buttons">
                <button
                  className="success-confirm-step__app-store-btn"
                  onClick={onDownloadAppStore}
                  type="button"
                >
                  <AppStore />
                </button>

                <button
                  className="success-confirm-step__play-store-btn"
                  onClick={onDownloadGooglePlay}
                  type="button"
                >
                  <PlayStore />
                </button>
              </div>
              {/*<Button
              className="success-confirm-step__home-btn"
              onClick={onGoToHome}
              variant="secondary"
              type="button"
            >
              Revenir à l'accueil
            </Button>*/}

            </div>

          </div>
        </div>
        <div>
          {/* Premium Offer */}
          <div className="success-confirm-step__offer">
            <span className="success-confirm-step__offer-title">Pour aller plus loin :</span>
            <div className="success-confirm-step__offer-card" onClick={onGoSubscribe}>
              <div className="success-confirm-step__offer-header">
                <h4 className="success-confirm-step__offer-name">OFFRE SÉRÉNITÉ</h4>
                <div className="success-confirm-step__offer-price">
                  <span className="success-confirm-step__offer-amount">2,90 €</span>
                  <span className="success-confirm-step__offer-period">/mois</span>
                </div>
              </div>
              <div className="success-confirm-step__offer-arrow">
                <RightArrow fill={"#12BC61"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default SuccessConfirmStep;